/* eslint-disable @typescript-eslint/no-unused-vars */
// import { PlinkoGame } from '@clawbuster/plinko-component/dist/components/plinko-game.js';
import App from './App.svelte';
import './styles/tailwind-global.css';

// Import web components
import IconAutocolor from './components/icons/icon-autocolor.svelte';
import IconAutoplay from './components/icons/icon-autoplay.svelte';
import IconBadFile from './components/icons/icon-bad-file.svelte';
import IconBetamount from './components/icons/icon-betamount.svelte';
import IconClose from './components/icons/icon-close.svelte';
import IconBack from './components/icons/icon-back.svelte';
import IconInfo from './components/icons/icon-info.svelte';
import IconLevelVolume from './components/icons/icon-level-volume.svelte';
import IconLock from './components/icons/icon-lock.svelte';
import IconMenu from './components/icons/icon-menu.svelte';
import IconMinus from './components/icons/icon-minus.svelte';
import IconNext from './components/icons/icon-next.svelte';
import IconPlay from './components/icons/icon-play.svelte';
import IconPlus from './components/icons/icon-plus.svelte';
import IconQuestion from './components/icons/icon-question.svelte';
import IconStop from './components/icons/icon-stop.svelte';

// customElements.define('plinko-game', PlinkoGame);

const app = new App({
    target: document.body
});

export default app;

addEventListener(
    'load',
    function () {
        window.scrollTo(1, 0);
    },
    false
);
